import { gql } from '@apollo/client';
import { FR_SERVICE_RECURRENT_METER_TYPE } from './service';
import { FR_INSPECTION_LIST_MACHINE_FIELDS } from './machine';
import { FR_INSPECTION_LIST_EQUIPMENT_FIELDS } from './equipment';
import { FR_ASSET_FIELDS } from './asset';
import { FR_MACHINE_TYPE_FIELDS } from './machineType';

export const FR_INSPECTION_OPTION_FIELDS = gql`
    fragment fr_InspectionOptionFields on InspectionOption {
        InspectionOptionId
        fi_name: Name(LangCode: FI)
        sv_name: Name(LangCode: SV)
        en_name: Name(LangCode: EN)
        no_name: Name(LangCode: NO)
        Success
        LimitValue
        UseInCount
        SecondLimitValue
        LimitValueType {
            ConditionTypeId
            Name
        }
        SecondLimitValueType {
            ConditionTypeId
            Name
        }
    }
`;

export const FR_INSPECTION_LIST_NAME_ID_FIELDS = gql`
    fragment fr_InspectionListNameIdFields on InspectionList {
        InspectionListId
        fi_Name: Name(LangCode: FI)
        en_Name: Name(LangCode: EN)
        sv_Name: Name(LangCode: SV)
        no_Name: Name(LangCode: NO)
        fi_Desc: Description(LangCode: FI)
        en_Desc: Description(LangCode: EN)
        sv_Desc: Description(LangCode: SV)
        no_Desc: Description(LangCode: NO)
    }
`;

export const FR_INSPECTION_LIST_FIELDS = gql`
    fragment fr_InspectionListFields on InspectionList {
        InspectionListId
        fi_name: Name(LangCode: FI)
        sv_name: Name(LangCode: SV)
        en_name: Name(LangCode: EN)
        no_name: Name(LangCode: NO)
        fi_description: Description(LangCode: FI)
        sv_description: Description(LangCode: SV)
        en_description: Description(LangCode: EN)
        no_description: Description(LangCode: NO)
        InspectionListType
        Private
        RecurrentMeterType {
            ...fr_ServiceRecurrentMeterTypeFields
        }
        RecurrentType {
            Name
        }
        Static {
            ProjectCount
            EquipmentCount
            MachineCount
            OrganizationCount
        }
        InspectionTask {
            InspectionTaskId
            Name
            sv_name: Name(LangCode: SV)
            en_name: Name(LangCode: EN)
            no_name: Name(LangCode: NO)
            Order
            ServiceWork {
                Name
                sv_name: Name(LangCode: SV)
                en_name: Name(LangCode: EN)
                no_name: Name(LangCode: NO)
            }
            InspectionType {
                InspectionTypeId
                Name
            }
            InspectionOption {
                ...fr_InspectionOptionFields
            }
            InspectionItem {
                InspectionItemId
                Category {
                    CategoryId
                    Name
                    sv_name: Name(LangCode: SV)
                    en_name: Name(LangCode: EN)
                    no_name: Name(LangCode: NO)
                }
                ServiceWork {
                    ServiceWorkId
                    Name
                    sv_name: Name(LangCode: SV)
                    en_name: Name(LangCode: EN)
                    no_name: Name(LangCode: NO)
                }
                Assembly {
                    AssemblyId
                    Name
                    sv_name: Name(LangCode: SV)
                    en_name: Name(LangCode: EN)
                    no_name: Name(LangCode: NO)
                }
                Component {
                    ComponentId
                    Name
                    sv_name: Name(LangCode: SV)
                    en_name: Name(LangCode: EN)
                    no_name: Name(LangCode: NO)
                }
            }
        }
        ProjectInspection {
            ProjectInspectionId
            Project {
                ProjectId
                ProjectNbr
                Name
            }
        }
        MachineInspection {
            MachineInspectionId
            MachineId
            Machine {
                ...fr_InspectionListMachineFields
            }
            Mandatory
            InspectionListId
            Created
            Updated
            StartDate
            EndDate
        }
        EquipmentInspection {
            EquipmentInspectionId
            EquipmentId
            Equipment {
                ...fr_InspectionListEquipmentFields
            }
            InspectionListId
            Created
            Updated
        }
        InspectionWorkflow {
            InspectionWorkflowId
            InspectionTask {
                InspectionTaskId
                fi_name: Name(LangCode: FI)
                sv_name: Name(LangCode: SV)
                en_name: Name(LangCode: EN)
                no_name: Name(LangCode: NO)
            }
            Enabled
            Email
            WorkflowAction {
                WorkflowActionId
                Name
            }
            WorkflowTrigger {
                WorkflowTriggerId
                Name
            }
            Created
            Updated
        }
        RecurrentCycle
        Created
        Updated
        Access {
            Read
            Create
            Delete
            Update
        }
        OrganizationAccess {
            Organization {
                OrganizationId
                Name
            }
            OrganizationAccessType {
                __typename
                ... on InspectionListOrganizationType {
                    InspectionListOrganizationTypeId
                    Name
                }
            }
        }
    }
    ${FR_SERVICE_RECURRENT_METER_TYPE}
    ${FR_INSPECTION_LIST_MACHINE_FIELDS}
    ${FR_INSPECTION_OPTION_FIELDS}
    ${FR_INSPECTION_LIST_EQUIPMENT_FIELDS}
`;

export const FR_INSPECTION_TASK_FIELDS = gql`
    fragment fr_InspectionTaskFields on InspectionTask {
        InspectionTaskId
        fi_name: Name(LangCode: FI)
        sv_name: Name(LangCode: SV)
        en_name: Name(LangCode: EN)
        no_name: Name(LangCode: NO)
        fi_instruction: Instruction(LangCode: FI)
        sv_instruction: Instruction(LangCode: SV)
        en_instruction: Instruction(LangCode: EN)
        no_instruction: Instruction(LangCode: NO)
        Order
        Private
        InspectionEntryCount
        FailedInspectionEntryCount
        InspectionListCount
        InspectionTaskType
        InspectionList {
            InspectionListId
            fi_name: Name(LangCode: FI)
            sv_name: Name(LangCode: SV)
            en_name: Name(LangCode: EN)
            no_name: Name(LangCode: NO)
        }
        InspectionType {
            Name
        }
        InspectionItem {
            InspectionItemId
            Category {
                CategoryId
                Name
                sv_name: Name(LangCode: SV)
                en_name: Name(LangCode: EN)
                no_name: Name(LangCode: NO)
            }
            ServiceWork {
                ServiceWorkId
                Name
                sv_name: Name(LangCode: SV)
                en_name: Name(LangCode: EN)
                no_name: Name(LangCode: NO)
            }
            Assembly {
                AssemblyId
                Name
                sv_name: Name(LangCode: SV)
                en_name: Name(LangCode: EN)
                no_name: Name(LangCode: NO)
            }
            Component {
                ComponentId
                Name
                sv_name: Name(LangCode: SV)
                en_name: Name(LangCode: EN)
                no_name: Name(LangCode: NO)
            }
        }
        ServiceWork {
            ServiceWorkId
            Name
            sv_name: Name(LangCode: SV)
            en_name: Name(LangCode: EN)
            no_name: Name(LangCode: NO)
        }
        InspectionOption {
            ...fr_InspectionOptionFields
        }
        Created
        Updated
        Access {
            Read
            Create
            Delete
            Update
        }
        OrganizationAccess {
            Organization {
                OrganizationId
                Name
            }
            OrganizationAccessType {
                __typename
                ... on InspectionTaskOrganizationType {
                    InspectionTaskOrganizationTypeId
                    Name
                }
            }
        }
    }
    ${FR_INSPECTION_OPTION_FIELDS}
`;

export const FR_INSPECTION_ENTRY_TASK_FIELDS_LITE = gql`
    fragment fr_InspectionEntryTaskFieldsLite on InspectionEntryTask {
        InspectionEntryTaskId
        Value
        Success
    }
`;

export const FR_INSPECTION_ENTRY_TASK_FIELDS = gql`
    fragment fr_InspectionEntryTaskFields on InspectionEntryTask {
        InspectionEntryTaskId
        Value
        Success
        Comment
        Created
        Updated
        InspectionOption {
            ...fr_InspectionOptionFields
        }
        InspectionTask {
            ...fr_InspectionTaskFields
        }
        InspectionIssue {
            IssueId
            Description
            Summary
            IssueType
        }
        Issue {
            IssueId
            Description
            Summary
            IssueSource {
                Name
            }
        }
        InspectionEntryFile {
            InspectionEntryFileId
            File {
                FileId
                FileName
                FolderName
                FileTempLink
            }
        }
    }
    ${FR_INSPECTION_TASK_FIELDS}
    ${FR_INSPECTION_OPTION_FIELDS}
`;

export const FR_INSPECTION_MACHINE_FIELDS_FRAGMENT = gql`
    fragment fr_InspectionMachineFields on Machine {
        MachineId
        Name
        SerialNbr
        InServiceDate
        OperationHours {
            Latest
        }
        Organization {
            OrganizationId
            Name
            Logo
            Address {
                StreetAddr
                PostalCode
                City
            }
        }
        MachineType {
            ...fr_MachineTypeFields
        }
        Asset {
            AssetName
            AssetType
        }
    }
    ${FR_MACHINE_TYPE_FIELDS}
`;

export const FR_INSPECTION_ENTRY_FIELDS = gql`
    fragment fr_InspectionEntryFields on InspectionEntry {
        InspectionEntryId
        Name
        Description
        OperatingHours
        Date
        InspectionEntryStatus {
            Name
        }
        Asset {
            ...fr_AssetFields
        }
        Signature {
            InspectionEntrySignatureId
            Signature
            User {
                UserId
                Fullname
            }
            Created
            Updated
        }
        InspectionList {
            InspectionListId
            fi_name: Name(LangCode: FI)
            sv_name: Name(LangCode: SV)
            en_name: Name(LangCode: EN)
            no_name: Name(LangCode: NO)
            fi_description: Description(LangCode: FI)
            sv_description: Description(LangCode: SV)
            en_description: Description(LangCode: EN)
            no_description: Description(LangCode: NO)
            InspectionListType
            InspectionTask {
                ...fr_InspectionTaskFields
            }
        }
        InspectionEntryCreator {
            UserId
            Fullname
            Phone
        }
        InspectionEntryTask {
            ...fr_InspectionEntryTaskFields
        }
        Created
        InspectionEntryCreator {
            Firstname
            Lastname
        }
        Project {
            Name
            ProjectId
            ProjectNbr
            Addr
        }
        Updated
        x
        y
        Access {
            Read
            Create
            Delete
            Update
        }
    }
    ${FR_ASSET_FIELDS}
    ${FR_INSPECTION_ENTRY_TASK_FIELDS}
    ${FR_INSPECTION_TASK_FIELDS}
`;

export const FR_INSPECTION_ENTRY_LIST_FIELDS = gql`
    fragment fr_InspectionEntryListFields on InspectionEntry {
        InspectionEntryId
        Name
        Description
        Date
        InspectionEntryStatus {
            Name
        }
        Asset {
            ...fr_AssetFields
        }
        InspectionEntryCreator {
            UserId
            Fullname
            Phone
        }
        InspectionEntryTask {
            ...fr_InspectionEntryTaskFieldsLite
        }
        Created
        Project {
            Name
            ProjectId
            ProjectNbr
            Addr
        }
        Updated
        Access {
            Read
            Create
            Delete
            Update
        }
    }
    ${FR_ASSET_FIELDS}
    ${FR_INSPECTION_ENTRY_TASK_FIELDS_LITE}
`;